import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { toggleSwitch, popUpMenuChange } from '../../../actions/index'
import { _ } from '../../../functions/translator'
import { ToggleActions } from '../../../constants/constants';
import AddCosts from '../../menu/addCosts';

class AddCostsButton extends React.Component{

    handleClick = () => {
        this.props.toggleSwitch(ToggleActions.CHANGE_CATEGORY_COMPONENT, true);
        this.props.popUpMenuChange({ show: false });
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} >
                    <AddCosts popUpMenu={true}></AddCosts>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        toggleSwitch : toggleSwitch,
        popUpMenuChange : popUpMenuChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddCostsButton)